import {html, HTMLTemplateResult} from "lit";
import {customElement} from "lit/decorators/custom-element.js";
import {get} from "lit-translate";

import {AbstractLitElement} from "../../abstract-lit.element";

/**
 * Placeholder shown in the Knowledge view pane when no KnowledgeObject
 * is selected. Light DOM is inherited from AbstractLitElement (ADR-007).
 */
@customElement('knowledge-empty-state')
export class KnowledgeEmptyState extends AbstractLitElement {

    protected render(): HTMLTemplateResult {
        return html`<p class="knowledge-empty-state__message">${get('wissen.view.empty-state')}</p>`;
    }
}
